import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import {  useHistory } from 'react-router-dom'
import  {faSignInAlt, faSignOutAlt, faSpinner} from '@fortawesome/free-solid-svg-icons'
import { Greet } from '../components/DashboardComponent'
import { TransactionsList, DepositOrWithdraw, Display } from '../components/TransactionComponent'
import BalanceStatement from '../components/modals/BalanceStatement'
import RemittanceStatement from '../components/modals/RemittanceStatement'
import IncomeStatement from '../components/modals/IncomeStatement'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getUser } from '../utils/profile';

const Transactions = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [, setIsPending] = useState(false)
    const [, setError] = useState(null)

    useEffect(() => {
        document.title = 'Pouch | Transactions'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            console.log(user)
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Navbar />
            {profile && <div className="container">
                {/* Transactions hero */}
                <div className="row mx-1 my-3">
                    <Greet />
                </div>
                <div className="row d-flex justify-content-around text-white">
                    <div className="col-md mx-4 p-3 dash-card bg-1 h6 display-6">
                        <Display title="Total Balance" amount={profile.balance.integerValue} />
                        <Display title="Total Income" amount={200000} />
                        <Display title="Total Remittance" amount={100000} />
                        <p className="float-right">
                            <DepositOrWithdraw title="Deposit" icon={faSignInAlt} />
                            <DepositOrWithdraw title="Withdraw" icon={faSignOutAlt} />
                        </p>
                    </div>
                </div>

                <hr className="bg-purple" />

                {/* Wallet and quick transfer */}
                
                <div className="row shadow-lg p-3 my-3">
                    <div className="col py-2">
                        <p className="pb-3 m-0">
                            <h6>Transactions
                                <select onChange={() => {}} name="" className="float-right rounded px-2 py-1 btn btn-outline-purple">
                                    {['Today', 'This Year', 'This Week', 'This Month'].map((ele, idx) => <option key={idx} value={ele}>{ele}</option>)}
                                </select>
                            </h6>
                        </p>
                        
                        <p>                            
                        <table className="w-100 border-bottom my-2">
                            <thead>
                                <tr>
                                    <td rowSpan="2" ></td>
                                    <td className="text-center">Beneficiary</td>
                                    <td className="text-center" rowSpan="2" >Category</td>
                                    <td className="text-right"><span className=" rounded p-1">Price</span></td>
                                </tr>
                                <tr className="text-muted small">
                                    <td className="text-center">Description</td>
                                    <td className="text-right">Date</td>
                                </tr>
                            </thead>
                        </table>
                        </p>
                        <p style={{ maxHeight : '180px', overflow : 'auto'}}>
                            {[1, 2, 3, 4, 5, 6].map(ele => {
                                return (
                                    <TransactionsList
                                        key={ele} status="Completed"
                                        name="Amazon Store" category="Lifestyle"
                                        rise="-$28.34" desc="Books"
                                        date="12 Feb 2018"
                                    />
                                )
                            })}
                        </p>
                    </div>
                </div>
            </div>}
            {!profile && 
                <p className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh'}}>                    
                    <FontAwesomeIcon icon={faSpinner} spin className="h3 display-4" />
                </p>
            }
            <BalanceStatement />  
            <RemittanceStatement />
            <IncomeStatement />
        </>
    )
}

export default Transactions